export default {
    book: 'Резервирай {product}',
    age_limit: 'Само за лица над {age} години',
    change_plan: 'Промени план',
    upgrade_product: 'Ъпгрейд на продукта',
    upgrade: 'Ъпгрейд',
    cancel_upgrade: 'Откажи ъпгрейд',
    choose_product: 'Избери {product}',
    days: '{count} ден | {count} дни',
    login_register: 'Вход/Регистрация',
    current: 'Текущ',
    keyless_benefits: {
        label: 'Директно до колата {0}',
        highlight: 'услуга за наем™',
        list: {
            cant_lose_the_key: 'Пълна застраховка',
            zero_excess: 'Без самоучастие',
            phone_as_a_key: 'Телефон като ключ',
            straight_to_car: 'Без чакане',
            no_queues: 'Без опашки',
            online_id_check: 'Онлайн проверка на лични данни',
            self_checkout: 'Самостоятелно настаняване',
        },
    },
};
